//@ts-check

/**
 * @type {import("./types").cleanPathType}
 */
export default function cleanPath(path) {
  if (!path) return path;
  return path.split('\\').join('/');
}